import { HttpRequest } from '@angular/common/http';

export abstract class IInterceptorFilter {
  abstract skipIf(interceptor: unknown, req: HttpRequest<unknown>): boolean;
}
